__turbopack_context__.v({
  "button": "LinkButton-module__4wJBJq__button",
});
